export const hoverExcludingChildHover = `&:not(:has(.hover-child:hover)):hover`;
